import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Breadcrumb } from '../../components/breadcrumbs/breadcrumbs.component';
import { Category } from '../../types/event-response.type';
import { map, Observable } from 'rxjs';
import { getCategoryBreadcrumbsUtil } from '../../utils/getCategooryBreadcrumbs.util';
import { findCategoryUtil } from '../../utils/findCategory.util';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'app-browse-categories',
  templateUrl: './browse-categories.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrowseCategoriesComponent {
  public activeCategory: Category | null = null;

  public allCategories$: Observable<Category[]> = this.route.data.pipe(
    map((data) => data['categories'])
  );

  public categoryId$: Observable<number | null> = this.route.params.pipe(
    map((data) => Number(data['category_id']) ?? null)
  );

  constructor(
    private route: ActivatedRoute,
    private navigation: NavigationService
  ) {}

  getCategories(categoryId: number, allCategories: Category[]): Category[] {
    this.activeCategory = findCategoryUtil(allCategories, categoryId);

    return this.activeCategory
      ? this.activeCategory?.subcategories ?? []
      : allCategories;
  }

  getBreadcrumbs(
    categories: Category[],
    targetId: number | null
  ): Breadcrumb[] {
    return getCategoryBreadcrumbsUtil(categories, targetId);
  }

  async goToCategory(category_id: number): Promise<void> {
    await this.navigation.goToResultsByCategoryId([category_id]);
  }
}
